import React from 'react';
import {
  CheckoutContext,
  CheckoutState,
  CheckoutStateAction,
  DEFAULT_CHECKOUT_STATE,
} from './context';

const reducer = (state: CheckoutState, action: CheckoutStateAction) => {
  switch (action.type) {
    case 'SET_PAGE':
      return {
        ...state,
        page: action.payload,
      };
    case 'SET_SELECTED_PAYMENTS_GROUP':
      return {
        ...state,
        selectedPaymentsGroup: action.payload,
      };
    case 'SET_SELECTED_SPLIT_PAYMENTS_GROUP_ID':
      return {
        ...state,
        selectedSplitPaymentsGroupId: action.payload,
      };
    default:
      return state;
  }
};

export function CheckoutProvider({ children }: React.PropsWithChildren) {
  const [state, dispatch] = React.useReducer(reducer, DEFAULT_CHECKOUT_STATE);

  const contextValue = React.useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state, dispatch],
  );

  return (
    <CheckoutContext.Provider value={contextValue}>
      {children}
    </CheckoutContext.Provider>
  );
}
